import { create } from 'zustand';

export type AnnouncementInitialDefaults = {
	title?: string;
	description?: string;
	end_date?: string;
	start_date?: string;
	email_notification?: boolean;
	send_slack_message?: boolean;
	send_ms_teams_message?: boolean;
	claimable_award_id?: string;
	full_width_image?: boolean;
	image?: File;
	recipients?: string[];
	reason_tokens?: any[];
};

type MakeAnnouncementModalStoreProps = {
	isOpen: boolean;
	hideManageLink?: boolean;
	initialDefaults?: AnnouncementInitialDefaults;
	onClose: () => void;
	onOpen: (options?: { hideManageLink?: boolean; initialDefaults?: AnnouncementInitialDefaults }) => void;
};

export const useMakeAnnouncementModalStore = create<MakeAnnouncementModalStoreProps>((set) => ({
	isOpen: false,
	hideManageLink: undefined,
	initialDefaults: undefined,
	onClose: () => set({ isOpen: false, hideManageLink: undefined, initialDefaults: undefined }),
	onOpen: (options?: unknown) => {
		// Defensively handle non-object values (e.g., click events passed by onClick handlers)
		const hideManageLink = options && typeof options === 'object' && 'hideManageLink' in options ? (options.hideManageLink as boolean) : undefined;
		const initialDefaults =
			options && typeof options === 'object' && 'initialDefaults' in options ? (options.initialDefaults as AnnouncementInitialDefaults) : undefined;
		set({ isOpen: true, hideManageLink, initialDefaults });
	},
}));

export const useMakeAnnouncementModal = () => useMakeAnnouncementModalStore((state) => state);
